"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { recordMatchEvent } from "@/app/gaseste-terapeut/actions";
import { trackEvent, trackMetaStandardEvent } from "@/lib/analytics";
import { ATTRIBUTION_LAST_TOUCH_KEY } from "@/lib/attribution";

interface Props {
  therapistId: string;
  therapistName: string;
}

export default function ProfileTracker({ therapistId, therapistName }: Props) {
  const searchParams = useSearchParams();

  useEffect(() => {
    trackEvent("view_therapist_profile", {
      therapist_id: therapistId,
      therapist_name: therapistName,
    });
    trackMetaStandardEvent("ViewContent", {
      content_name: therapistName,
      content_type: "therapist_profile",
      content_ids: [therapistId],
    });

    // URL params first (no race condition), fall back to localStorage
    const stored = (() => {
      try {
        const raw = window.localStorage.getItem(ATTRIBUTION_LAST_TOUCH_KEY);
        return raw ? (JSON.parse(raw) as Record<string, string | null>) : {};
      } catch { return {}; }
    })();

    const attribution = {
      utm_source: searchParams.get("utm_source") ?? stored.utm_source ?? null,
      utm_medium: searchParams.get("utm_medium") ?? stored.utm_medium ?? null,
      utm_campaign: searchParams.get("utm_campaign") ?? stored.utm_campaign ?? null,
      utm_content: searchParams.get("utm_content") ?? stored.utm_content ?? null,
      utm_term: searchParams.get("utm_term") ?? stored.utm_term ?? null,
      fbclid: searchParams.get("fbclid") ?? stored.fbclid ?? null,
      gclid: searchParams.get("gclid") ?? stored.gclid ?? null,
    };

    void recordMatchEvent({
      therapistId,
      landingUrl: window.location.href,
      attribution,
    });
  }, [therapistId, therapistName]);

  return null;
}
